<template>
    <!--<h1>{{ selectedCourseType }}</h1> -->
    <div class="courseSelector">
        <fieldset class="courseSelector__container" v-if="showSelector">
            <legend class="courseSelector__headline">{{ $t('formHeadline') }}<span class="form__required-indicator">*</span></legend>
            <div v-if="splitWholeYear">
                <!-- Split year courses -->
                <div class="courseTypeSelector__selector">
                    <input class="courseSelector__input form__input--radio courseSelector__input"
                        type="radio"
                        :id="'coursetype_6'"
                        name="courseType"
                        required
                        :value="6"
                        v-model="selectedCourseType"
                        v-on:change="updateSelectedCourseType">
                    <label class="courseSelector__label" :for="'coursetype_6'">
                        {{
                            ((this.courseTypes[1] && this.courseTypes[6]) ?
                                (locale === "no" ? 'Helår sammensatt av to linjefag' : 'Full year with two subjects') :
                                (locale === "no" ? 'Helår' : 'Full year')
                            ) + ' ' + getCourseTypeYearFullYear()
                        }}
                    </label>
                </div>
            </div>
            <div v-for="courseType in courseTypes" :key="courseType.id">
                <!-- Regular coursetypes -->
                <div class="courseTypeSelector__selector"
                    v-if="courseType.id != 6 && courseType.id != 7 && courseType.id !=9 && courseType.id !=11">
                    <input class="form__input form__input--radio courseSelector__input"
                        type="radio"
                        :id="'coursetype_' + courseType.id"
                        name="courseType"
                        required
                        :value="courseType.id"
                        v-model="selectedCourseType"
                        v-on:change="updateSelectedCourseType">
                    <label class="courseSelector__label" :for="'coursetype_' + courseType.id">
                        <span v-if="courseType.id == 3">
                            {{ (locale === "no" ? courseType.name_no : courseType.name_en) + ' ' + getCourseTypeYearSpring() }}
                        </span>
                        <span v-else-if="courseType.id == 2">
                            {{ (locale === "no" ? courseType.name_no : courseType.name_en) + ' ' + getCourseTypeYearAutumn() }}
                        </span>
                        <span v-else-if="courseType.id == '2-a' || courseType.id == '3-a'">
                            {{ (locale === "no" ? courseType.name_no : courseType.name_en) }}
                        </span>
                        <span v-else>
                            {{ (locale === "no" ? courseType.name_no : courseType.name_en) + ' ' + getCourseTypeYearFullYear() }}
                        </span>

                    </label>
                </div>
            </div>
        </fieldset>

        <div class="courseSelector__container" v-if="selectedCourseType">
            <div v-if="selectedCourseType != 'composite'">
                <CourseSelectorList
                    :title="(selectedCourseType == 6 || selectedCourseType == 8 || selectedCourseType == 10) ? 'formHeadlineCourse1' : 'formHeadlineCourse'"
                    defaultOption="formDefaultOptionCourse"
                    :courseTypeError="courseTypeError"
                    :courses="courseTypes[selectedCourseType].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="0"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
            </div>
            <div v-else>
                <CourseSelectorList
                    title="Linjefag høst"
                    defaultOption="formDefaultOptionCourse"
                    :courseTypeError="courseTypeError"
                    :courses="courseTypes[2].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="0"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
                <CourseSelectorList
                    title="Linjefag vår"
                    defaultOption="formDefaultOptionCourse"
                    :courseTypeError="courseTypeError"
                    :courses="courseTypes[3].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="1"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
            </div>

            <!-- Course selector for second class in split year courses -->
            <div v-if="selectedCourseType == 6" class="courseSelector__inner-container courseSelector--secondary">
                <CourseSelectorList
                    title="formHeadlineCourse2"
                    defaultOption="formDefaultOptionCourse2"
                    :courseTypeError="courseType2Error"
                    :courses="courseTypes[7].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="1"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
            </div>
            <div v-if="selectedCourseType == 8" class="courseSelector__inner-container courseSelector--secondary">
                <CourseSelectorList
                    title="formHeadlineCourse2"
                    defaultOption="formDefaultOptionCourse2"
                    :courseTypeError="courseType2Error"
                    :courses="courseTypes[9].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="1"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
            </div>
            <div v-if="selectedCourseType == 10" class="courseSelector__inner-container courseSelector--secondary">
                <CourseSelectorList
                    title="formHeadlineCourse2"
                    defaultOption="formDefaultOptionCourse2"
                    :courseTypeError="courseType2Error"
                    :courses="courseTypes[11].courses"
                    :locale="$i18n.locale"
                    :selectedCourses="selectedCourses"
                    :selectedIndex="1"
                    @updateSelectedCourseList="updateSelectedCourses"
                    >
                </CourseSelectorList>
            </div>
        </div>
    </div>
</template>
<script>
import CourseSelectorList from './CourseSelectorList.vue';

export default {
    components: {
        CourseSelectorList
    },
    props: [
        'courses',
        'courseTypes',
        'courseTypeError',
        'courseType2Error',
        'urlCourses',
        'urlCourseType',
        'locale',
        'selectedCourses',
        'globals',
    ],
    emits: [
        'updateSelectedCourses',
        'updateSelectedCourseType',
    ],
    data() {
        return{
            selectedCourseType: null,
        }
    },
    methods: {
        updateSelectedCourseType() {
            this.$emit('updateSelectedCourseType', this.selectedCourseType);
        },
        updateSelectedCourses(event = null, index = null) {
            this.$emit('updateSelectedCourses', this.selectedCourses);
        },
        getCourseTypeYearFullYear(){
            if (this.globals && this.globals.application_year) {
                return this.globals.application_year + '-' + (this.globals.application_year + 1);
            } else {
                return "";
            }
        },
        getCourseTypeYearAutumn() {
            if (this.globals && this.globals.application_halfyear_autumn) {
                return this.globals.application_halfyear_autumn;
            } else {
                return "";
            }
        },
        getCourseTypeYearSpring() {
            if (this.globals && this.globals.application_halfyear_spring) {
                return this.globals.application_halfyear_spring;
            } else {
                return "";
            }
        },
    },
    computed: {
        splitWholeYear() {
            const courseTypeIds = Object.keys(this.courseTypes);
            return courseTypeIds.includes('6') && courseTypeIds.includes('7');
        },
        showSelector() {
            if(Object.keys(this.courseTypes).length > 1){
                return true;
            } else {
                this.selectedCourseType = Object.keys(this.courseTypes)[0];
                this.updateSelectedCourseType();
                return false;
            }

        },
    },
    watch: {
        courseTypes() {
            if (this.courseTypes[1] && this.courseTypes[6]) {
                // if we have both whole year and split courses, the split courses should be first
                this.selectedCourseType = 6;
            } else {
                const firstType = Number(Object.keys(this.courseTypes)[0]);
                this.selectedCourseType = firstType;
            }
            let hasValidCourse = false;
            const searchParams = (new URL(window.location.href)).searchParams;
            if (searchParams.has('courses')) {
                const courseIds = searchParams.get('courses').split(',');
                hasValidCourse = Object.values(this.courseTypes).some(ct => ct.courses?.some(c => courseIds.includes(String(c.id))));
            }
            if (!hasValidCourse) {
                this.updateSelectedCourseType();
            }
        },
        urlCourseType() {
            this.selectedCourseType = this.urlCourseType;
        },
    }
}
</script>